:root {
  --semantic-notifications-error-border: var(--semantic-colors-notification-error);
  --semantic-notifications-error-bg: var(--semantic-colors-bg-secondary);
  --semantic-notifications-error-body: var(--semantic-colors-typography-body);
  --semantic-notifications-error-heading: var(--semantic-colors-typography-heading);
  --semantic-notifications-error-icon-right: var(--semantic-colors-icons-default);
  --semantic-notifications-error-icon-left: var(--semantic-colors-icons-error);
  --semantic-notifications-information-border: var(--semantic-colors-notification-success);
  --semantic-notifications-information-bg: var(--semantic-colors-bg-secondary);
  --semantic-notifications-information-body: var(--semantic-colors-typography-body);
  --semantic-notifications-information-heading: var(--semantic-colors-typography-heading);
  --semantic-notifications-information-icon-right: var(--semantic-colors-icons-default);
  --semantic-notifications-information-icon-left: var(--semantic-colors-icons-information);
  --semantic-notifications-success-border: var(--semantic-colors-notification-success);
  --semantic-notifications-success-bg: var(--semantic-colors-bg-secondary);
  --semantic-notifications-success-body: var(--semantic-colors-typography-body);
  --semantic-notifications-success-heading: var(--semantic-colors-typography-heading);
  --semantic-notifications-success-icon-right: var(--semantic-colors-icons-default);
  --semantic-notifications-success-icon-left: var(--semantic-colors-icons-success);
  --semantic-notifications-warning-border: var(--semantic-colors-notification-warning);
  --semantic-notifications-warning-bg: var(--semantic-colors-bg-secondary);
  --semantic-notifications-warning-body: var(--semantic-colors-typography-body);
  --semantic-notifications-warning-heading: var(--semantic-colors-typography-heading);
  --semantic-notifications-warning-icon-right: var(--semantic-colors-icons-default);
  --semantic-notifications-warning-icon-left: var(--semantic-colors-icons-warning);
}
